import { render, staticRenderFns } from "./CertificatesDetails.vue?vue&type=template&id=5002bb6c&scoped=true"
import script from "./CertificatesDetails.vue?vue&type=script&lang=js"
export * from "./CertificatesDetails.vue?vue&type=script&lang=js"
import style0 from "./CertificatesDetails.vue?vue&type=style&index=0&id=5002bb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5002bb6c",
  null
  
)

export default component.exports